import React from "react";
import ArrowLeft from "../../img/ArrowLeft";
import "./styles.css";

function BackButton({ onClick }) {
  return (
    <button className="backButton" onClick={onClick}>
      <ArrowLeft />
      <p>Regresar</p>
    </button>
  );
}

export default BackButton;
